/**
* 微信用户
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>微信用户</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="searchForm" class="user-search">
      <el-form-item label="昵称">
        <el-input size="small" v-model="searchForm.nickname" placeholder="输入昵称" clearable></el-input>
      </el-form-item>
      <el-form-item label="电话">
        <el-input size="small" v-model="searchForm.phoneNumber" placeholder="输入电话" clearable></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select size="small" v-model="searchForm.userStatus" placeholder="请选择状态" clearable>
          <el-option
              v-for="item in userStatusList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-download" :loading="exportloading" @click="handleExport">导出</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="nickname" label="昵称">
      </el-table-column>
      <el-table-column prop="phoneNumber" label="电话">
      </el-table-column>
      <el-table-column prop="sex" label="性别" :formatter="sexFormatter">
      </el-table-column>
      <el-table-column prop="userStatus" label="状态" :formatter="userStatusFormatter">
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="150">
        <template v-slot:default="scope">
          <div>{{ scope.row.updateTime|timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="400">
        <template v-slot:default="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="primary" @click="handleStatus(scope.row, 2)" v-if="scope.row.userStatus==0||scope.row.userStatus==1">授权</el-button>
          <el-button size="mini" type="danger" @click="handleStatus(scope.row, 0)" v-if="scope.row.userStatus==2">取消授权</el-button>
          <el-button size="mini" type="danger" @click="handleStatus(scope.row, 4)" v-if="scope.row.userStatus!=4">禁用用户</el-button>
          <el-button size="mini" type="primary" @click="handleStatus(scope.row, 0)" v-if="scope.row.userStatus==4">取消禁用</el-button>
          <el-button size="mini" type="primary" @click="handleStatus(scope.row, 6)" v-if="scope.row.userStatus!=6">设置管理员</el-button>
          <el-button size="mini" type="primary" @click="handleStatus(scope.row, 0)" v-if="scope.row.userStatus==6">撤回管理员</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="80px" :model="editForm" :rules="rules" ref="editForm" class="form-dialog">
        <el-form-item label="昵称" prop="nickname">
          <el-input size="small" v-model="editForm.nickname" auto-complete="off" placeholder="请输入昵称"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phoneNumber">
          <el-input size="small" v-model="editForm.phoneNumber" auto-complete="off" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select size="small" v-model="editForm.sex" placeholder="请选择状态">
            <el-option
                v-for="item in sexList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {wxUserExport, wxUserList, wxUserSave, wxUserStatus} from '../../api/api'
import {sexDict, userStatusDict} from '../../utils/dict'
import {parseTime} from '../../utils/util'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      loading: false, //是显示加载
      exportloading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        nickname: '',
        phoneNumber: '',
        sex: ''
      },
      // rules表单验证
      rules: {
        questionBankId: [
          {required: true, message: '请输入题目', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入题目', trigger: 'blur'}
        ]
      },
      searchForm: {
        page: 1,
        limit: 10,
        nickname: '',
        phoneNumber: '',
        userStatus: ''
      },
      // 删除部门
      seletedata: {
        ids: ''
      },
      listData: [],
      userStatusList: userStatusDict,
      sexList: sexDict,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.getData(this.searchForm)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取微信用户一览
    getData(parameter) {
      this.loading = true
      wxUserList(parameter)
          .then(res => {
            this.loading = false
            this.listData = res.rows;
            this.pageparm.currentPage = this.searchForm.page
            this.pageparm.pageSize = this.searchForm.limit
            this.pageparm.total = res.total
          })
          .catch(err => {
            this.loading = false
            this.$message.error('查询失败！')
          })
    },
    // 分页插件事件
    callFather(parm) {
      this.searchForm.page = parm.currentPage
      this.searchForm.limit = parm.pageSize
      this.getData(this.searchForm)
    },
    // 搜索事件
    search() {
      this.getData(this.searchForm)
    },
    /** 导出按钮操作 */
    handleExport() {
      let _this = this;
      _this.exportloading = true
      let filename = `用户得分详情导出_${parseTime(new Date(), '{y}{m}{d}_{h}{i}{s}')}.xlsx`;
      wxUserExport(this.searchForm, filename)
          .then(res => {
            _this.exportloading = false
          })
          .catch(err => {
            _this.exportloading = false
            _this.$message.error('导出失败！')
          })

    },
    // 显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      this.title = '修改'
      this.editForm.id = row.id
      this.editForm.nickname = row.nickname
      this.editForm.phoneNumber = row.phoneNumber
      this.editForm.sex = row.sex
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          wxUserSave(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code === 200) {
                  this.getData(this.searchForm)
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              }).catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('保存失败，请稍后再试！')
          })
        } else {
          return false
        }
      })
    },
    // 删除维度 wxUserStatus
    handleStatus(row, status) {
      let msg = '确定要禁用该用户吗?';
      if (status == 2) {
        msg = '确定要授权给该用户吗?';
      } else if (status == 0) {
        msg = '确定要改变该用户状态吗?';
      }
      this.$confirm(msg, '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {id: row.id, userStatus: status};
        wxUserStatus(param)
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  type: 'success',
                  message: '状态改变成功!'
                })
                this.getData(this.searchForm)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
          this.loading = false
          this.$message.error('状态改变失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    // 性别格式化
    sexFormatter(row, column, cellValue, index) {
      const item = this.sexList.find(item => item.id === cellValue)
      return item ? item.name : cellValue
    },
    // 状态格式化
    userStatusFormatter(row, column, cellValue, index) {
      const item = this.userStatusList.find(item => item.id === cellValue)
      return item ? item.name : cellValue
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.form-dialog .el-input {
  width: 350px;
}

.form-dialog .el-select {
  width: 350px;
}
</style>





// WEBPACK FOOTER //
// src/views/wxUser/WxUser.vue